export default __webpack_public_path__ + "static/media/app-icon-gray.1ca0e1bd.svg";